<template>
  <div v-if="banners.length > 0" class="mt-4">
    <v-alert
      v-for="banner in banners"
      :key="banner.id"
      border="top"
      dark
      :color="mapVariantToColor(banner.style)">
      <span v-html="banner.body"/>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'RemoteBanners',
  data () {
    return {
      banners: []
    }
  },
  props: {
    customerId: Number
  },
  methods: {
    /**
     * Borrowed from AppBanners.vue
     * @param variant
     * @returns {string}
     */
    mapVariantToColor (variant) {
      switch (variant) {
        case 'danger':
          return 'error darken-1'
        case 'warning':
          return 'warning darken-1'
        case 'success':
          return 'success darken-1'
        default:
          return 'primary'
      }
    },
    async loadBanners () {
      try {
        const response = await this.$orm('Banner').findAll({
          customer_id: this.customerId,
          visible: 1,
          sort: '-updated',
          fields: 'customer_id,visible,body,type,style'
        })
        this.banners = response.getItems()
      } catch (error) {
        this.handleError(error)
      }
    }
  },
  sockets: {
    'banners-updated' () {
      this.loadBanners()
    }
  },
  watch: {
    customerId () {
      this.loadBanners()
    }
  }
}

</script>

<style>
/* Remove the bottom margin of the last p tag in the banner, to avoid weird a weird gap at the bottom. */
.remote-banner-content p:last-child {
  margin-bottom: 0;
}
</style>
